/** @jsx React.DOM */
var React = require('react/addons')
var num = require('num')
var remotes = require('../../../helpers/remotes')
var numbers = require('../../../helpers/numbers')
var constants = require('../../../helpers/constants')
var formatters = require('../../../helpers/formatters')
var transactionsHelper = require('../../../helpers/transactions')
var TransactionDescription = require('../../../partials/rmc/transaction-description')
var AccountLink = require('../../../partials/rmc/account-link')
var config = require('json!../../../config.json')

var Transaction = React.createClass({displayName: 'Transaction',
  getInitialState: function() {
    return {
      tx: null
    }
  },

  fetch: function() {
    var remote = remotes.nodes
    remote.requestTransaction(this.props.params.hash, function(err, res) {
      if (err) throw err
      this.setState({
        tx: res
      })
    }.bind(this))
  },

  componentWillMount: function() {
    document.title = this.props.params.hash + config.documentTitleSuffix
    this.fetch()
  },

  render: function() {
    var hash = this.props.params.hash
    var tx = this.state.tx

//    console.log(tx)

    return React.DOM.div({className: "container"}, 
      React.DOM.h1({title: hash}, hash.substr(0, 7)), 

      React.DOM.table({className: "table table-bordered table-striped"}, 
        React.DOM.tbody(null, 
          React.DOM.tr(null, 
            React.DOM.th(null, "Account"), 
            React.DOM.td(null, tx && AccountLink({id: tx.Account}))
          ), 
          React.DOM.tr(null, 
            React.DOM.th(null, "Type"), 
            React.DOM.td(null, tx && tx.TransactionType)
          ), 
          tx && tx.ClearFlag && React.DOM.tr(null, 
            React.DOM.th(null, "ClearFlag"), 
            React.DOM.td(null, tx.ClearFlag)
          ), 
          tx && tx.Domain && React.DOM.tr(null, 
            React.DOM.th(null, "Domain"), 
            React.DOM.td(null, formatters.escapeHtml(formatters.hex_to_ascii(tx.Domain)))
          ), 
          tx && tx.EmailHash && React.DOM.tr(null, 
            React.DOM.th(null, "EmailHash"), 
            React.DOM.td(null, tx.EmailHash)
          ), 
          tx && tx.MessageKey && React.DOM.tr(null, 
            React.DOM.th(null, "MessageKey"), 
            React.DOM.td(null, tx.MessageKey)
          ), 
          tx && tx.SetFlag && React.DOM.tr(null, 
            React.DOM.th(null, "SetFlag"), 
            React.DOM.td(null, tx.SetFlag)
          ), 
          tx && tx.TransferRate && React.DOM.tr(null, 
            React.DOM.th(null, "TransferRate"), 
            React.DOM.td(null, formatters.formatAmount(tx.TransferRate))
          ), 
          tx && tx.TickSize && React.DOM.tr(null, 
            React.DOM.th(null, "TickSize"), 
            React.DOM.td(null, tx.TickSize)
          ), 
          React.DOM.tr(null, 
            React.DOM.th(null, "Ledger"), 
            React.DOM.td(null, tx && tx.inLedger)
          ), 
          React.DOM.tr(null, 
            React.DOM.th(null, "Sequence"), 
            React.DOM.td(null, tx && tx.Sequence)
          ), 
          React.DOM.tr(null, 
            React.DOM.th(null, "Time"), 
            React.DOM.td(null, tx && formatters.date(formatters.networkEpochToDate(tx.date)))
          ), 
          React.DOM.tr(null, 
            React.DOM.th(null, "Fee"), 
            React.DOM.td(null, tx && formatters.formatAmount(tx.Fee))
          ), 
          tx && tx.TakerPays && React.DOM.tr(null, 
            React.DOM.th(null, "Taker pays"), 
            React.DOM.td(null, formatters.formatAmount(tx.TakerPays))
          ), 
          tx && tx.TakerGets && React.DOM.tr(null, 
            React.DOM.th(null, "Taker gets"), 
            React.DOM.td(null, formatters.formatAmount(tx.TakerGets))
          ), 
          tx && tx.Destination && React.DOM.tr(null, 
            React.DOM.th(null, "Destination"), 
            React.DOM.td(null, AccountLink({id: tx.Destination}))
          ), 
          tx && tx.InvoiceID !== undefined && React.DOM.tr(null, 
            React.DOM.th(null, "Invoice ID"), 
            React.DOM.td(null, tx.InvoiceID)
          ), 
          tx && tx.DestinationTag !== undefined && React.DOM.tr(null, 
            React.DOM.th(null, "Destination tag"), 
            React.DOM.td(null, tx.DestinationTag)
          ), 
          tx && tx.SourceTag !== undefined && React.DOM.tr(null, 
            React.DOM.th(null, "Source tag"), 
            React.DOM.td(null, tx.SourceTag)
          ), 
          tx && tx.Amount && React.DOM.tr(null, 
            React.DOM.th(null, "Amount"), 
            React.DOM.td(null, formatters.formatAmount(tx.Amount))
          ), 
          tx && tx.meta.DeliveredAmount && React.DOM.tr(null, 
            React.DOM.th(null, "Delivered Amount"), 
            React.DOM.td(null, formatters.formatAmount(tx.meta.DeliveredAmount))
          ), 
          tx && tx.Flags !== undefined && React.DOM.tr(null, 
            React.DOM.th(null, "Flags"), 
            React.DOM.td(null, tx.Flags)
          )
        )
      )
    )
  }
})

module.exports = Transaction



//////////////////
// WEBPACK FOOTER
// ./src/routes/rmc/transaction/index.jsx
// module id = 474
// module chunks = 0